import styled from "@emotion/styled";
import { border, padding } from "polished";

import { UnstyledButton } from "@brexhq/next/src/components/shared/UnstyledButton/UnstyledButton";
import { Text } from "@brexhq/shared/components/Typography/Text";

export const SignupHeader = styled.div(({ theme }) => ({
  color: theme.colors.content.primary,
  zIndex: theme.zIndex.HEADER,
  backgroundColor: theme.colors.background.primary,
  position: "sticky",
  top: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: 80,
  ...padding(theme.spacing[16], 0, theme.spacing[24], 0),
  [theme.breakpoints.SML]: {
    paddingTop: theme.spacing[16],
  },
}));

export const Constraint = styled.div(({ theme }) => ({
  width: "100%",
  maxWidth: 450,
  [theme.breakpoints.SML]: {
    width: "100%",
    ...padding(0, theme.spacing[24]),
  },
}));

const marginOverride = {
  margin: 0,
};

export const TitleContainer = styled.div(({ theme }) => ({
  ...marginOverride,
  paddingBottom: theme.spacing[36],
  [theme.breakpoints.phone]: {
    paddingBottom: theme.spacing[20],
  },
}));

export const SubTitle = styled.p(({ theme }) => ({
  ...marginOverride,
  marginTop: theme.spacing[12],
  color: theme.colors.content.secondary,
  ...theme.typography.BodyLargeM,
  [theme.breakpoints.phone]: {
    ...theme.typography.BodySmallM,
  },
}));

export const Form = styled.form(({ theme }) => ({
  display: "grid",
  gridRowGap: theme.spacing[20],
}));

export const InputsRow = styled.div(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gridColumnGap: theme.spacing[24],
  gridRowGap: theme.spacing[32],
}));

export const ActionsBox = styled.div(({ theme }) => ({
  paddingTop: theme.spacing[36],
}));

export const BackButton = styled(UnstyledButton)<{ center?: boolean }>(
  ({ theme, center }) => ({
    color: theme.colors.accent.primary.background.default,
    maxWidth: 70,
    marginRight: center ? 0 : theme.spacing.m60,
    [theme.breakpoints.SML]: {
      marginRight: center ? 0 : theme.spacing.p24,
    },
  }),
);

export const FooterBox = styled.div(({ theme }) => ({
  marginTop: theme.spacing.m20,
  ...padding(theme.spacing.p56, 0),
  maxWidth: 680,
  width: "100%",
  [theme.breakpoints.SML]: {
    ...padding(theme.spacing.p32, 0),
    marginTop: theme.spacing.m10,
  },
}));

export const DisclosureText = styled.p(({ theme }) => ({
  ...marginOverride,
  ...theme.typography.DetailLargeR,
  color: theme.colors.content.primary,
}));

export const DisclosureIcon = styled.div(({ theme }) => ({
  color: theme.colors.content.primary,
  paddingRight: theme.spacing[8],
}));

export const PrimaryButtonContainer = styled.div({
  maxWidth: 250,
  flexGrow: 1,
});

export const SubmitError = styled.div(({ theme }) => ({
  ...theme.typography.DetailLargeR,
  color: theme.colors.negative.default,
  paddingBottom: theme.spacing[16],
}));

export const Line = styled.div(({ theme }) => ({
  ...border("bottom", 1, "solid", theme.colors.border.default),
  flexGrow: 1,
}));

export const SeparatorText = styled.h2(({ theme }) => ({
  ...marginOverride,
  ...theme.typography.DetailLargeR,
  padding: theme.spacing[4],
}));

export const Separator = styled.div(({ theme }) => ({
  color: theme.colors.border.default,
  display: "flex",
  alignItems: "center",
  paddingTop: theme.spacing[32],
}));

export const SubText = styled.p(({ theme }) => ({
  ...theme.typography.DetailLargeM,
  color: theme.colors.content.secondary,
  marginTop: theme.spacing[12],
  marginBottom: 0,
}));

export const LearnMoreText = styled.p(({ theme }) => ({
  marginBottom: 0,
  color: theme.colors.accent.primary.background.muted,
}));

export const DisclaimerText = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing[12],
  paddingLeft: theme.spacing[24],
}));
